export default __webpack_public_path__ + "static/media/ebd160735e22f99f.5dc2aea6d7dbad56794cb27d70ab71ac.svg";